import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  LabelValueSource,
  LabelType,
  LabelValueAcceptedBy
} from 'graphql/types';
import { DependantLabelData, DependantLabels } from '../components/schema';

const isLabelASuggestion = (dependentLabel?: DependantLabelData): boolean =>
  (dependentLabel?.label?.value?.idValue &&
    dependentLabel?.label.valueSource === LabelValueSource.Suggestion) ||
  false;

const setAcceptedByToUser = (
  label: DependantLabelData,
  setValue: UseFormReturn['setValue'],
  timesheetLabelsFormField: string
) => {
  setValue(
    `${timesheetLabelsFormField}.${label.index}.label`,
    {
      ...label.label,
      acceptedBy: LabelValueAcceptedBy.User,
      valueSource: label.label.valueSource ?? LabelValueSource.User
    },
    { shouldValidate: true, shouldDirty: true }
  );
};

export const useUpdateDependentLabelsValueSourceOnSelection = (
  dependentLabels: DependantLabels,
  type: LabelType,
  timesheetLabelsFormField: string,
  setValue: UseFormReturn['setValue']
): (() => void) => {
  return useCallback(() => {
    switch (type) {
      case LabelType.Billing:
        if (
          dependentLabels.task.label.value?.stringValue &&
          dependentLabels.task.label.valueSource === LabelValueSource.Suggestion
        ) {
          setAcceptedByToUser(
            dependentLabels.task,
            setValue,
            timesheetLabelsFormField
          );
        }
        if (isLabelASuggestion(dependentLabels.project)) {
          setAcceptedByToUser(
            dependentLabels.project,
            setValue,
            timesheetLabelsFormField
          );
        }
        if (
          isLabelASuggestion(dependentLabels?.client) &&
          dependentLabels?.client
        ) {
          setAcceptedByToUser(
            dependentLabels.client,
            setValue,
            timesheetLabelsFormField
          );
        }
        if (
          isLabelASuggestion(dependentLabels?.program) &&
          dependentLabels?.program
        ) {
          setAcceptedByToUser(
            dependentLabels.program,
            setValue,
            timesheetLabelsFormField
          );
        }
        break;
      case LabelType.Task:
        if (isLabelASuggestion(dependentLabels.project)) {
          setAcceptedByToUser(
            dependentLabels.project,
            setValue,
            timesheetLabelsFormField
          );
        }
        if (
          isLabelASuggestion(dependentLabels.client) &&
          dependentLabels.client
        ) {
          setAcceptedByToUser(
            dependentLabels.client,
            setValue,
            timesheetLabelsFormField
          );
        }
        if (
          isLabelASuggestion(dependentLabels?.program) &&
          dependentLabels?.program
        ) {
          setAcceptedByToUser(
            dependentLabels.program,
            setValue,
            timesheetLabelsFormField
          );
        }
        break;
      case LabelType.Project:
        if (
          isLabelASuggestion(dependentLabels.client) &&
          dependentLabels.client
        ) {
          setAcceptedByToUser(
            dependentLabels.client,
            setValue,
            timesheetLabelsFormField
          );
        }
        if (
          isLabelASuggestion(dependentLabels?.program) &&
          dependentLabels?.program
        ) {
          setAcceptedByToUser(
            dependentLabels.program,
            setValue,
            timesheetLabelsFormField
          );
        }

        break;
    }
  }, [
    dependentLabels.client,
    dependentLabels.program,
    dependentLabels.project,
    dependentLabels.task,
    setValue,
    timesheetLabelsFormField,
    type
  ]);
};
